<template>
  <!-- 物联网设备信息 -->
  <div class="firecontrol">
    <!--
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form class="bginput" style="margin-bottom: 0.8rem;" label-width="8rem">
          <el-form-item label="物联网设备信息">
            <el-select v-model="set.getType" placeholder="请选择" style="width:100%">
              <el-option label="手动录入" :value="0"></el-option>
              <el-option label="后台获取" :value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row> -->
    <el-table class="eltabletl" border :data="tableData" style="width: 50%">
      <el-table-column prop="devName" label="设备名称"></el-table-column>
      <el-table-column prop="model" label="设备类型"></el-table-column>
      <el-table-column prop="status" label="设备状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status===0">离线</span>
          <span v-if="scope.row.status===1">在线</span>

        </template>

      </el-table-column>
      <el-table-column prop="area" label="区域"></el-table-column>
      <el-table-column prop="linkUser" label="负责人"> </el-table-column>
      <el-table-column width="200" fixed="right">
        <template slot="header">
           操作 <i @click="addRow()" style="font-size: 1.2rem;font-weight: 600;cursor:pointer;position: relative;top: 0.1rem;color: #00ffff;" class="el-icon-circle-plus-outline"></i>
        </template>
        <template slot-scope="scope">
          <el-button @click="edit(scope.row); activeName= 'info';fileList=[]" type="text">修改</el-button>
          <el-button @click="del(scope.row) " type="text">删除</el-button>

        </template>
      </el-table-column>
    </el-table>
    <el-dialog v-dialogDrag title="物联网设备信息" :close-on-click-modal="false" :visible.sync="xfboxdialog" class="xfdialog">
      <el-tabs v-model="activeName">
        <el-tab-pane name="info">
          <span slot="label" >基本信息</span>
          <div class="info">
            <div class="img">
              <h3 class="h-title">设备图片</h3>
              <el-upload action="#" :limit="20" :file-list="fileList" list-type="picture-card" :http-request="uploadfile" :multiple='false' :auto-upload="true">
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{file}">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                  <span class="el-upload-list__item-actions">

                    <!-- <span class="el-upload-list__item-preview" @click="view(file)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
                      <i class="el-icon-download"></i>
                    </span> -->

                    <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
              <el-dialog v-dialogDrag :visible.sync="dialogVisible">
                <img style=" width: 100%;;height: 24rem" :src="dialogImageUrl" alt="">
              </el-dialog>
            </div>
            <div class="form">
              <h3 class="h-title">设备信息</h3>
              <el-form ref="formData" label-width="5rem">
                <el-form-item label="设备名称">
                  <el-input v-model="formData.safeFighting.devName" placeholder="请输入"></el-input>
                </el-form-item>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="设备品牌">
                      <el-input v-model="formData.safeFighting.devBrand" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="设备型号">
                      <el-input v-model="formData.safeFighting.model" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="采集类别">
                      <el-select v-model="formData.safeFighting.collectType" placeholder="请选择">
                        <el-option label="电参量" value="电参量"></el-option>
                        <el-option label="水量" value="水量"></el-option>
                        <el-option label="燃气" value="燃气"></el-option>
                        <el-option label="电气火灾" value="电气火灾"></el-option>
                        <el-option label="温度" value="温度"></el-option>
                        <el-option label="电气火灾含电参量" value="电气火灾含电参量"></el-option>
                        <el-option label="基站电池" value="基站电池"></el-option>
                        <el-option label="制冷设备" value="制冷设备"></el-option>
                        <el-option label="环境" value="环境"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="网络类型">
                      <el-select v-model="formData.safeFighting.netType" placeholder="请选择">
                        <el-option label="5G无线网络" value="5G无线网络"></el-option>
                        <el-option label="4G无线网络" value="4G无线网络"></el-option>
                        <el-option label="3G无线网络" value="3G无线网络"></el-option>
                        <el-option label="2G无线网络" value="2G无线网络"></el-option>
                        <el-option label="wifi无线网络" value="wifi无线网络"></el-option>
                        <el-option label="有线网络" value="有线网络"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item label="安装区域">
                  <el-input v-model="formData.safeFighting.area" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="负责人">
                  <el-input v-model="formData.safeFighting.linkUser" placeholder="请输入"></el-input>

                </el-form-item>
                <el-form-item label="生产日期">

                  <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd" style="width: 100%;" v-model="formData.safeFighting.produceDate" type="date" placeholder="选择日期时间"> </el-date-picker>

                </el-form-item>
                <el-form-item label="安装日期">

                  <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd" style="width: 100%;" v-model="formData.safeFighting.installDate" type="date" placeholder="选择日期时间"> </el-date-picker>

                </el-form-item>
                <el-form-item label="售后截止">

                  <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd" style="width: 100%;" v-model="formData.safeFighting.byDate" type="date" placeholder="选择日期时间"> </el-date-picker>

                </el-form-item>
                <el-form-item label="生产厂商">
                  <el-input v-model="formData.safeFighting.customName" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="使用状态">
                  <el-select v-model="formData.safeFighting.useStatus" placeholder="请选择">
                    <el-option label="未正常使用" :value="0"></el-option>
                    <el-option label="正常使用" :value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="保养周期">
                  <el-input v-model="formData.safeFighting.maintain" placeholder="请输入">
                    <template slot="suffix">天/次</template>

                  </el-input>
                </el-form-item>
                <el-form-item label="维保单位">
                  <el-input v-model="formData.safeFighting.maintainCompany" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="当前状态">

                  <el-select v-model="formData.safeFighting.status" placeholder="请选择">
                    <el-option label="离线" :value="0"></el-option>
                    <el-option label="在线" :value="1"></el-option>
                  </el-select>

                </el-form-item>
              </el-form>
            </div>

          </div>
        </el-tab-pane>

        <el-tab-pane name="gq">
          <span slot="label">运维记录</span>

          <table class="mytable">
            <thead>
              <tr>
                <td>日期</td>
                <td>维保类型</td>
                <td>维保单位</td>
                <td>维保人员</td>
                <td>维保结果</td>
                <td>备注</td>
                <td style="width:150px">操作
                  <i @click="addyunweiRow()" style="font-size: 1.2rem;font-weight: 600;cursor:pointer;position: relative;top: 0.1rem;color: #00ffff;" class="el-icon-circle-plus-outline"></i>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,i) in formData.safeOps" :key='i'>
                <td>
                  <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd" style="width: 100%;" v-model="item.opsDate" type="date" placeholder="选择日期时间"> </el-date-picker>
                </td>
                <td>
                  <el-select v-model="item.opsType" placeholder="请选择">
                    <el-option label="维修" value="维修"></el-option>
                    <el-option label="更换" value="更换"></el-option>
                    <el-option label="巡检" value="巡检"></el-option>
                  </el-select>
                </td>
                <td>
                  <el-input v-model="item.opsCompany" placeholder="请输入"></el-input>
                </td>
                <td>
                  <el-input v-model="item.opsUser" placeholder="请输入"></el-input>
                </td>
                <td>
                  <el-input v-model="item.opsResult" placeholder="请输入"></el-input>
                </td>
                <td>
                  <el-input v-model="item.remark" placeholder="请输入"></el-input>
                </td>

                <td>
                  <el-button @click="opsDelete(item,i)" type="text">删除</el-button>
                </td>
              </tr>
            </tbody>
          </table>

        </el-tab-pane>

        <!-- <el-tab-pane name="wby">
          <span slot="label">关联表计</span>
          <div class="dialogcontent">
            <table class="mytable">
              <thead>
                <tr>
                  <td>表计类型</td>
                  <td>表计编号</td>
                  <td>表计名称</td>
                  <td>操作
                    <i @click="addbiaoRow()" style="font-size: 1.2rem;font-weight: 600;cursor:pointer;position: relative;top: 0.1rem;color: #00ffff;" class="el-icon-circle-plus-outline"></i>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,i) in formData.safeIotRelation" :key='i'>

                  <td>
                    <el-select v-model="item.iotType" placeholder="请选择">
                      <el-option label="电参量" value="电参量"></el-option>
                      <el-option label="水量" value="水量"></el-option>
                      <el-option label="电气火灾含电参量" value="电气火灾含电参量"></el-option>
                      <el-option label="燃气" value="燃气"></el-option>
                      <el-option label="电气火灾" value="电气火灾"></el-option>
                      <el-option label="温度" value="温度"></el-option>
                      <el-option label="制冷设备" value="制冷设备"></el-option>
                    </el-select>
                  </td>
                  <td>
                    <el-input v-model="item.iotNum" placeholder="请输入"></el-input>
                  </td>
                  <td>
                    <el-input v-model="item.iotName" placeholder="请输入"></el-input>
                  </td>

                  <td>
                    <el-button @click="relationDelete(item,i)" type="text">删除</el-button>
                  </td>
                </tr>
              </tbody>
            </table>

          </div>
        </el-tab-pane> -->

      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button @click="save" type="primary">保存</el-button>
        <el-button @click="xfboxdialog = false">关闭</el-button>

      </span>

    </el-dialog>
    <el-dialog v-dialogDrag :visible.sync="dialogVisible">
      <img style=" width: 100%;;height: 24rem" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import upapi from '@/apis/upload'
import api from '@/apis/device/netThings'
export default {
  data() {
    return {
      xfboxdialog: false,
      dialogVisible: false,
      disabled: false,
      dialogImageUrl: '',
      set: {
        getType: 0,
      },
      fileList: [],

      tableData: [],
      activeName: 'info',

      formData: {
        //消防设备
        safeFighting: {},
        //表计关联
        safeIotRelation: [],
        //运维记录
        safeOps: [],
      },
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    getlist() {
      api
        .list({
          params: {
            limit: 100,
            page: 1,
          },
        })
        .then((res) => {
          if (res.code === 10000) {
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        })
    },
    //添加数据
    addRow() {
      this.activeName = 'info'
      this.fileList = []
      this.formData = {
        //消防设备
        safeFighting: {
          address: '', //地址
          area: '', //区域
          byDate: '', //截至售后日期
          companyId: '',
          customName: '', //厂家
          devBrand: '', //品牌
          devName: '', //设备名称
          installDate: '', //安装日期
          linkUser: '', //负责人
          lat: '', //纬度
          lng: '', //经度
          maintain: '', //保养周期
          maintainCompany: '', //维保单位
          pictures: '', //图片
          produceDate: '', //生产日期
          runStatus: '', //运行状态 0关机 1正常
          status: 1, //当前状态 0临期 1正常 2过期 3 未即时保养
          useStatus: 1, //使用状态 0未正常使用 1 正常使用
        },
        //表计关联
        safeIotRelation: [
          // {
          //   iotName: '', //表计名称
          //   iotNum: '', //表计编号
          //   iotType: '', //表计类型
          // },
        ],
        //运维记录
        safeOps: [
          // {
          //   opsCompany: '', //维保单位
          //   opsDate: '', //维保日期
          //   opsResult: '', //维保结果
          //   opsType: '', //维保类型
          //   opsUser: '', //维保人员
          //   remark: '', //备注
          // },
        ],
      }

      this.xfboxdialog = true
    },
    edit(row) {
      api
        .info({
          params: {
            id: row.id,
          },
        })
        .then((res) => {
          if (res.code === 10000) {
            this.formData = res.data


            if (this.formData.safeFighting.pictures) {
              this.fileList = JSON.parse(this.formData.safeFighting.pictures)
            } else {
              this.fileList = []
            }

            this.xfboxdialog = true
          } else {
            this.$message.error(res.message)
          }
        })
    },
    del(row) {
      this.$confirm('确认删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        api.del({ params: { id: row.id } }).then((res) => {
          if (res.code == 10000) {
            this.$message.success(res.message)
            this.getlist()
          } else {
            this.$message.error(res.message)
          }
        })
      })
    },
    //表计管理删除
    relationDelete(row,index) {
      this.$confirm('确认删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if ( row.id) {
          
          api.relationDelete({ params: { id: row.id } }).then((res) => {
            if (res.code == 10000) {
              this.edit(this.formData.safeFighting)
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          })

        } else {
          this.formData.safeIotRelation.splice(index, 1)
        }
      })
    },
    //运维删除
    opsDelete(row,index) {
      this.$confirm('确认删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if ( row.id) {
          api.opsDelete({ params: { id: row.id } }).then((res) => {
            if (res.code == 10000) {
              this.edit(this.formData.safeFighting)
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          })          
          
        } else {
          this.formData.safeOps.splice(index, 1)
        }
      })
    },

    addyunweiRow() {
      if (this.formData.safeOps==null) {
        this.formData.safeOps = []
      }
      this.formData.safeOps.push({
        opsCompany: '', //维保单位
        opsDate: '', //维保日期
        opsResult: '', //维保结果
        opsType: '', //维保类型
        opsUser: '', //维保人员
        remark: '', //备注
      })
    },
    addbiaoRow() {
      if (this.formData.safeIotRelation==null) {
        this.formData.safeIotRelation = []
      }
      this.formData.safeIotRelation.push({
        iotName: '', //表计名称
        iotNum: '', //表计编号
        iotType: '', //表计类型
      })
    },

    //查看图片
    view(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //下载图片
    handleDownload(file) {
      open(file.url)
    },
    //上传图片
    uploadfile(val) {
      let fd = new FormData()
      fd.append('file', val.file)
      upapi.upload(fd).then((res) => {
        if (res.code == 10000) {
          // this.$message.success(res.message)

          this.fileList.push({
            name: val.file.name,
            url: res.data,
            uid: val.file.uid,
          })
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //删除图片
    handleRemove(file) {
      return this.$confirm(`确定移除此图片？`).then(() => {
        this.fileList.map((item, index) => {
          if (item.id == file.id) {
            // 删除
            api.del([file.id]).then((res) => {
              if (res.code === 10000) {
                this.$message.success(res.message)
              } else {
                this.$message.error(res.message)
              }
            })
            this.fileList.splice(index, 1)

            upapi
              .del({ params: { filePath: file.url } })
              .then
              //   (res) => {
              //   if (res.code == 10000) {
              //     //  this.$message.success(res.message)
              //
              //   } else {
              //     this.$message.error(res.message)
              //   }
              // }
              ()
          }
        })
      })
    },

    save() {
      this.formData.safeFighting.pictures = JSON.stringify(this.fileList)

      if (this.formData.safeFighting.id) {
        api.update(this.formData).then((res) => {
          if (res.code === 10000) {
            this.$message.success(res.message)
            this.getlist()
            this.xfboxdialog = false
          } else {
            this.$message.error(res.message)
          }
        })
      } else {
        api.save(this.formData).then((res) => {
          if (res.code === 10000) {
            this.$message.success(res.message)
            this.getlist()
            this.xfboxdialog = false
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
  },
}
</script>

<style scoped  lang="less">
.firecontrol {
  padding-top: 10px;
  /deep/ .el-button--text{ color: #00ccff; padding:2px .5rem;}
  .el-form-item {
    margin-bottom: 15px;
  }
  /deep/ .el-form-item__label {
    background: #3570ff;
  }
  .xfdialog {
    .el-select {
      width: 100%;
    }

    .el-upload-list li {
      width: 16rem !important;
      height: 11rem !important;
      margin: 10px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    /deep/ .el-upload-list li {
      width: 10rem !important;
      height: 10rem !important;
      margin: 10px;
    }

    /deep/ .el-upload-list__item {
      border-radius: 0;
    }
    /deep/ .el-upload--picture-card i {
      font-size: 2rem !important;
    }
    /deep/ .el-upload-list__item-actions span {
      font-size: 2rem;
    }
    /deep/ .el-upload--picture-card {
      background-color: transparent;
      width: 10rem !important;
      margin: 10px;
      height: 10rem !important;
      line-height: 9rem !important;
      text-align: center;
      border: #555e86 dashed 1px;
      font-size: 2rem;
      border-radius: 0;
    }

    /deep/ .el-dialog__body {
      min-height: 35rem; display: flex; flex-direction: column;
      .el-tabs--top{ flex: 1; display: flex; flex-direction: column; overflow: hidden;
        .el-tabs__header{ flex-shrink: 0;}
        .el-tabs__content{ flex: 1; height: 100%; overflow-y: auto;
          div{ height: 100%;}
        }
      }
    }


    .info {
      display: flex;
      .h-title {
        border-left: #3570ff solid 0.5em;
        line-height: 1.6em; padding-left:.6rem ;
        margin: 1em 0;
        font-size: 1.5em;
      }
      .img {
        width: 49%;
        margin-right: 1rem;
        flex-shrink: 0;
      }
      .form {
        flex: 1;
        width: 100%;
        overflow-y: auto;
        overflow: hidden;
      }
      .item {
        border-bottom: #555e86 dashed 1px;
        padding: 0.4rem 0.5rem;
        display: flex;
        flex-direction: row;
        label {
          width: 5rem;
          flex-shrink: 0;
          text-align: right;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-right: 10px;
        }
        span {
          color: #fff;
        }
      }
      .item:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>